/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import ReactDOM from 'react-dom';

import {Alert} from "@blueprintjs/core";
import {IconNames} from "@blueprintjs/icons";
import {Intent} from "@blueprintjs/core";

import {WrcGlobal} from "./WrcGlobal";
import $ from "jquery";

export class WrcServer {
    static errorMessage = (data) => ('ERROR ' + (data.status ? data.status : '') + ': ' + (data.status ? data.statusText : 'INTERNET CONNECTION LOST'));

    static post(call, data, successfunc, commonAjax=true){
        if (commonAjax) {
            call = "registry-common/ajax/" + call + ".php";
        } else {
            call = "ajax/" + call + ".php";
        }
        $.post(call, data, function (data) {
            let response = '';
            try {
                response = JSON.parse(data);
            } catch (err) {
                WrcGlobal.toasts.show({message: data, intent: Intent.DANGER });
                return;
            }

            switch (response['status']) {
                case -1:
                    let msg = response['content'];
                    ReactDOM.render(<Alert
                        confirmButtonText="OK"
                        isOpen={true}
                        intent={Intent.DANGER}
                        icon={IconNames.WARNING_SIGN}
                        onClose={WrcGlobal.logout}>
                        <p>
                            {msg}
                        </p>
                    </Alert>, document.querySelector('#alertdiv'));
                    break;
                case 0:
                    WrcGlobal.toasts.show({message: response['content'], intent: Intent.WARNING });
                    break;
                case 1:
                    successfunc(response['content']);
                    break;
                default:
                    WrcGlobal.toasts.show({message: 'Invalid response status', intent: Intent.DANGER });
            }
        }).fail(function (data) {
            WrcGlobal.toasts.show({message: WrcServer.errorMessage(data), intent: Intent.DANGER});
        });
    }

    static deepEquals(a, b) {
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (Object.keys(a).length != Object.keys(b).length) return false;
            for (var key in a) if (!this.deepEquals(a[key], b[key])) return false;
            return true;
        } else {
            return (a === null ? '' : a) === (b === null ? '' : b);
        }
    }
}
